// @flow
import React from 'react';
import { fromNow, resizeImage } from 'lib/common';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import 'moment/locale/ko';
import './EventCard.scss';

type Props = {
  id: string,
  thumbnail: string,
  title: string,
  body: string,
  urlSlug: string,
  oneColumn?: boolean,
  shortDescription: string,
  eventAt: string,
  eventStatus: boolean,
};

const EventCard = ({
  thumbnail,
  urlSlug,
  oneColumn,
  title,
  shortDescription,
  eventAt,
  eventStatus,
  isTrending,
}: Props) => {
  const link = `/@cacheby/events/${urlSlug}`;
  const imgUrl = resizeImage(thumbnail, 850, 252);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  const eventStatusText = eventStatus ? '종료' : '진행중';
  return (
    <div className={cx('EventCard', { 'one-column': oneColumn, empty: !thumbnail })}>
      {thumbnail && (
        <Link to={link} className={cx('thumbnail-wrapper')} style={style}>
          <div className="white-mask" />
        </Link>
      )}
      {!isTrending && (
        <div className="card-content">
          <div className="content-head">
            <div className={cx('eventStatus', { end: eventStatus })}>{eventStatusText}</div>
            <div className="eventAt">{eventAt}</div>
          </div>
        </div>
      )}
    </div>
  );
};

EventCard.defaultProps = {
  oneColumn: false,
  hideUsername: false,
};

export default EventCard;



// WEBPACK FOOTER //
// ./src/components/common/EventCard/EventCard.js